import React, { Fragment } from 'react';
import { Button, CustomInput } from 'reactstrap';

import SMSNumberField from './SmsNumberField';
import { SMS_ALERT_OBJECTS } from '../../constants/smsAlerts';

const checkDisabled = (alert_type, value) => {
  const selectedType = SMS_ALERT_OBJECTS.find(obj =>
    alert_type.includes(obj.value)
  );

  return selectedType && selectedType.disabledFields.includes(value);
};

const AlertTypes = ({ alert_type, handleOnSelect, types, name }) => {
  const emailInterval = types.map(({ label, value }) => {
    const isDisabled = checkDisabled(alert_type, value);
    const opacity = isDisabled ? 0.5 : 1;

    return (
      <p>
        <label style={{ opacity }} htmlFor={value} className="d-flex align-items-center">
          <CustomInput
            className="mr-2 d-inline"
            type="checkbox"
            id={value}
            key={value}
            value={value}
            name={name}
            checked={alert_type.includes(value)}
            onChange={handleOnSelect}
            disabled={isDisabled}
          />
          {label}
        </label>
      </p>
    );
  });

  return (
    <Fragment>
      <p>What type of alerts would you like to receive?</p>
      {emailInterval}
    </Fragment>
  );
};

const ConfigView = ({
  userName,
  userRole,
  is_active,
  alert_type,
  handleOnSelect,
  updateSmsAlertConfig,
  updateAlertPhoneNumber,
  types,
  name,
  sms_alert_number,
}) => {
  return (
    <div className="card card-body bg-light">
      <p>
        <span className="font-weight-bold">{userName}</span>
        <br />
        <span className="">{userRole}</span>
        <hr />
      </p>
      <p>
        <SMSNumberField
          updateAlertPhoneNumber={updateAlertPhoneNumber}
          sms_alert_number={sms_alert_number}
        />
      </p>
      <hr />
      <AlertTypes
        alert_type={alert_type}
        handleOnSelect={handleOnSelect}
        types={types}
        name={name}
      />
      <p>
        <Button
          className="email-settings-save-btn responsive-btn mt-2"
          onClick={updateSmsAlertConfig}
        >
          Save Alert Settings
        </Button>
      </p>
    </div>
  );
};

export default ConfigView;



// WEBPACK FOOTER //
// ./src/components/emailConfig/SMSAlertConfig.js